import React from "react";
import { Controller, useFormContext } from "react-hook-form";

type FormDateProps = {
  name?: string;
  type?: string;
  label?: string;
  errors?: boolean;
  errormessage?: string;
  placeholder?: string;
  defaultValue?: string;
  className?: string;
  inputClassName?: string;
  /** When true, uses fixed width (w-36) and height (32px) to align with other form fields in a row */
  sameSize?: boolean;
  [key: string]: unknown;
};

function FormDate({
  name,
  label,
  errors,
  errormessage,
  placeholder,
  defaultValue,
  className = "",
  inputClassName = "",
  sameSize = false,
  ...others
}: FormDateProps) {
  const { control } = useFormContext();
  const wrapperClass = sameSize ? `w-36 shrink-0 ${className}`.trim() : `w-full ${className}`.trim();
  const inputClass = inputClassName;

  return (
    <div className={`flex flex-col items-start gap-1.5 ${wrapperClass}`.trim()}>
      <label className="text-slate-700 dark:text-slate-300 text-[13px] font-medium leading-[1.4] capitalize">
        {label ?? "Date"}
      </label>

      <Controller
        name={name ?? ""}
        control={control}
        defaultValue={defaultValue ?? ""}
        render={({ field: { onChange, value } }) => (
          <input
            onChange={onChange}
            value={value}
            type="date"
            placeholder={placeholder ?? ""}
            required
            className={[
              "w-full px-2.5 flex items-center rounded-lg border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 text-xs text-slate-700 dark:text-slate-200 placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none focus:outline-none transition-all h-8",
              inputClass,
            ]
              .filter(Boolean)
              .join(" ")
              .trim()}
            {...others}
          />
        )}
      />
      {errors && (
        <label className="text-red-600 dark:text-red-400 text-[13px] font-normal leading-[1.4]">
          {errormessage ?? "Error"}
        </label>
      )}
    </div>
  );
}

export default FormDate;
